import React from 'react'
import FeatherIcon from 'feather-icons-react';
import MultiplierInput from 'components/Multipliers/MultiplierInput';


export default function CategoryMultiplierItem(props) {
    const {
        categoryItem,
        categoryItemIndex,
        handleCategoryNameClick,
        ExpandedCategories,
        handleExpandCategory,
        updateMultiplier, multipliers = []
    } = props

    let multiLevelCategories = null
    const multiplier = multipliers.find(e => e.category_id === categoryItem.category_id) || {}

    if (categoryItem?.sub_categories?.length) {
        multiLevelCategories = (
            <div className={`multilevel-container`}>
                {
                    categoryItem?.sub_categories?.length ? categoryItem?.sub_categories.map((item, index) => {
                        return (
                            <React.Fragment key={item.category_id}>
                                <CategoryMultiplierItem
                                    {...props}
                                    categoryItem={item}
                                    categoryItemIndex={index}
                                    handleCategoryNameClick={(ev, id) => handleCategoryNameClick(ev, id)}
                                    handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                                />
                            </React.Fragment>
                        )
                    }) : null
                }
            </div>
        )
    }

    return (
        <React.Fragment>

            <div className={`frac ${ExpandedCategories.find(item => item === categoryItem.category_id) ? "expanded" : "shrunk"}`}
                data-index={categoryItemIndex}
                data-key={categoryItem.category_id}
                key={categoryItem.category_id}>
                <div className="frac-item">
                    <div className="top-sec">
                        <div
                            className={`category-name d-flex justify-content-between align-items-center text-decoration-none ${categoryItem?.sub_categories ? "" : "category-subItem"}`}>
                            <span className="d-flex align-items-center">
                                {
                                    categoryItem?.sub_categories?.length ? (
                                        <button
                                            type="button"
                                            className="expand-shrink-icon st-round-btn st-btn-xs st-btn-white d-flex align-items-center justify-content-center me-2"
                                            onClick={ev => handleExpandCategory(ev, categoryItem.category_id)}>
                                            <FeatherIcon
                                                icon={ExpandedCategories.find(item => item === categoryItem.category_id) ? "minus" : "plus"}
                                                size="15"
                                                className="icon" />
                                        </button>
                                    ) :
                                        <FeatherIcon
                                            icon={categoryItem?.sub_categories ? "" : "circle"}
                                            size="8"
                                            className="icon me-1 expand-shrink-circle" />
                                }{categoryItem.category_name}</span>
                            <MultiplierInput
                                onChange={updateMultiplier}
                                id={categoryItem.category_id}
                                multiplier={multiplier.b_multiplier}
                                multiplierType={multiplier.b_multiplier_type}
                            />

                        </div>
                    </div>
                    {multiLevelCategories}
                </div>
            </div>
        </React.Fragment >
    )
}
